export default {
  info: {
    en: '*Apple Pay may charge $0.01 to authenticate your billing method. This charge will be refunded within 24 hours.',
  },
}
